import styled from '@emotion/styled';

export const AddButtonContainer = styled.div`
  width: 100%;
  max-width: 500px;
  min-width: 400px;
  height: 161px;
  border: 2px dashed #DDDDDD;
  border-radius: 8px;
  background: #FAFAFA;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  &:hover {
    border-color: #6A42F2;
    background: #F8F7FF;
  }
  
  &:hover .add-icon {
    color: #6A42F2;
  }
  
  &:hover .add-text {
    color: #6A42F2;
  }
  
  @media (max-width: 1200px) {
    max-width: 100%;
    min-width: 300px;
  }
`;

export const AddIcon = styled.div`
  font-size: 48px;
  color: #CCCCCC;
  margin-bottom: 8px;
  transition: color 0.2s ease;
`;

export const AddText = styled.span`
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  transition: color 0.2s ease;
`;